import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../auth";

export function ProtectedRoute() {
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const location = useLocation();

	if (!isAuthenticated()) {
		return (
			<Navigate
				to={"/login?next=" + encodeURIComponent(location.pathname)}
				replace
			/>
		);
	}

	return <Outlet />;
}

export default ProtectedRoute;
